module.exports = __webpack_public_path__ + "posture/static/img/boneCanvas.5e01079.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/bone/boneCanvas.png
// module id = W9R/
// module chunks = 1